// extracted by mini-css-extract-plugin
module.exports = {"pairs":"Pairs-styles_pairs__GqC6g","header":"Pairs-styles_header__rTP_s","heading":"Pairs-styles_heading__2fOyy","lanes":"Pairs-styles_lanes__3tnj-"};